var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BjDialog",
        {
          attrs: { title: _vm.title, visible: _vm.visible, width: "1100px" },
          on: { close: _vm.hide },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c("el-button", { on: { click: _vm.hide } }, [
                    _vm._v(_vm._s(_vm.$t("cancelText"))),
                  ]),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                    [_vm._v(_vm._s(_vm.$t("okText")))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("BjPage", {
            ref: "BjPage",
            attrs: {
              "query-params": _vm.queryParams,
              "col-span": _vm.colSpan,
              "label-width": "70px",
              "get-action": _vm.queryApi,
              serial: _vm.serial,
              stripe: false,
              selection: _vm.selection,
              "right-toolbar-hide": "",
              "no-auto-height": "",
              "is-list": "",
              "reset-data": _vm.resetData,
            },
            on: { handleSelectionChange: _vm.handleSelectionChange },
            scopedSlots: _vm._u([
              {
                key: "baseForm",
                fn: function () {
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessStockComDialogOrder.queryCode"
                              ),
                              prop: "queryCode",
                            },
                          },
                          [
                            _c("BjInputCode", {
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleQuery.apply(null, arguments)
                                },
                              },
                              model: {
                                value: _vm.queryParams.queryCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "queryCode", $$v)
                                },
                                expression: "queryParams.queryCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "tableTop",
                fn: function () {
                  return [
                    _c("div", { staticClass: "mb10" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("BusinessStockComDialogOrder.planNum")
                          ) +
                            "：" +
                            _vm._s(_vm.planNum)
                        ),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "tableColumn",
                fn: function () {
                  return [
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockComDialogOrder.platformOrderCode"
                        ),
                        prop: "platformOrderCode",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("BusinessStockComDialogOrder.orderCode"),
                        prop: "orderCode",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockComDialogOrder.orderCreationDate"
                        ),
                        prop: "orderCreationDate",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockComDialogOrder.stockoutQty"
                        ),
                        prop: "stockoutQty",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockComDialogOrder.scheduledDeliveryTime"
                        ),
                        prop: "scheduledDeliveryTime",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockComDialogOrder.replenishQty"
                        ),
                        prop: "replenishQty",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("BjInputNumber", {
                                attrs: {
                                  disabled: _vm.isView,
                                  max: props.row.stockoutQty,
                                  clearable: "",
                                },
                                model: {
                                  value: props.row.replenishQty,
                                  callback: function ($$v) {
                                    _vm.$set(props.row, "replenishQty", $$v)
                                  },
                                  expression: "props.row.replenishQty",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockComDialogOrder.priorityGrade"
                        ),
                        prop: "priorityGrade",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("BjInputNumber", {
                                attrs: { disabled: _vm.isView },
                                model: {
                                  value: props.row.priorityGrade,
                                  callback: function ($$v) {
                                    _vm.$set(props.row, "priorityGrade", $$v)
                                  },
                                  expression: "props.row.priorityGrade",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }